import { forwardRef, useRef, useEffect } from "react";
import {
  useTextField,
  VisuallyHidden,
  type AriaTextFieldProps,
} from "react-aria";
import styles from "./FormInput.module.css";

interface FormInputProps extends AriaTextFieldProps {
  maxLength?: number;
  onSubmit: () => void;
}
export const FormInput = forwardRef<HTMLInputElement, FormInputProps>(
  function AssetControlInputForm(props, ref) {
    const { label } = props;

    const innerRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
      if (typeof ref === "function") {
        ref(innerRef.current);
      } else if (ref) {
        ref.current = innerRef.current;
      }
    }, [ref]);

    const { labelProps, inputProps } = useTextField(props, innerRef);

    return (
      <form onSubmit={props.onSubmit}>
        <VisuallyHidden>
          <label {...labelProps} htmlFor="asset-rename">
            {label}
          </label>
        </VisuallyHidden>
        <input
          {...inputProps}
          ref={innerRef}
          className={styles.input}
          id="asset-rename"
          name="asset-rename"
          maxLength={props.maxLength}
        />
      </form>
    );
  },
);
